module.exports = __webpack_public_path__ + "static/img/299.b973984.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/299.png
// module id = zd0U
// module chunks = 0